import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import CardComponent from "./components/CardComponent/CardComponent";
import { Doughnut, Bar } from "react-chartjs-2";
import DashboardServices from "../../services/DibyaServices/DashboardServices/DashboardServices";
import { Chart, ArcElement, registerables } from "chart.js";
import OrderServices from "../../services/DibyaServices/OrderServices/OrderServices";
import UpcomingEvents from "./UpcomingEvents";
import LatestCustomer from "./LatestCustomer";
import DashboardService from "../../services/DashboardService/DashboardService";
import NewBookingList from "./NewBookingList";
import Widgets from "./components/CardComponent/Widgets";
import BestSellingProducts from "./components/CardComponent/BestSellingProducts";
import Revenue from "./components/CardComponent/Revenue";
import QRCodeGenerator from "../QRMenu/component/Qrgenerator";
import DaybookService from "../../services/OrderingServices/DaybookService";
import TableService from "../../services/OrderingServices/TableService";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import SettingService from "../../services/OrderingServices/SettingService";
import DayCloseDashboard from "./components/CardComponent/DayCloseDashboard";

Chart.register(ArcElement);
Chart.register(...registerables);

const doughnutOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Amount",
    },
  },
  cutoutPercentage: 50,
};

const barOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Amount",
    },
  },
  elements: {
    bar: {
      borderRadius: 10,
    },
  },
  maintainAspectRatio: false,
};

const statusConfig = {
  Available: { color: "#28a745", icon: "bx bx-check-circle" },
  Reserved: { color: "#ffc107", icon: "bx bx-time-five" },
  Occupied: { color: "#dc3545", icon: "bx bx-user" },
  Unavailable: { color: "#6c757d", icon: "bx bx-block" },
  UnderMaintenance: { color: "#0d6efd ", icon: "bx bx-wrench" },
  TotalCount: { color: "#20c997", icon: "bx bx-user" },
};
export default function Dashboard() {
  // const [data, setData] = useState({});
  // const [cardData, setCardData] = useState([]);
  // const [donutData, setDonutData] = useState([]);
  // const [barData, setBarData] = useState([]);
  // const [flashMessage, setFlashMessage] = useState("");
  // const [pendingOrder, setPendingOrder] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  // console.log("🚀 ~ Calender ~ user:", user);
  const driverId = user?.user?.id;
  // console.log("🚀 ~ Calender ~ driverId:", driverId);
  const userType = user?.user?.user_type;

  const [data, setData] = useState({
    barData: [],
    cash_total: 0,
    card_total: 0,
  }); // Initialize state
  const [loading, setLoading] = useState(true); // To indicate loading state
  const [error, setError] = useState(); // To hold any error
  useEffect(() => {
    const fetchCosmosData = async () => {
      try {
        let result; // Declare a variable to store the API response
        if (userType === "DRIVER") {
          result = await DashboardService.getData(driverId);
        } else {
          result = await DashboardService.getData(); // Fetch general data for other user types
        }
        setData(result); // Set the result to state
      } catch (err) {
        setError(err); // Capture any error
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchCosmosData(); // Execute the fetch function
  }, [userType, driverId]); // Add dependencies if `userType` or `driverId` might change

  // Prepare data for the Doughnut chart
  const doughnutChartData = {
    labels: ["Cash Total", "Card Total"],
    datasets: [
      {
        data: [data.cash_total, data.card_total], // Use the totals for doughnut
        backgroundColor: ["#FF6384", "#36A2EB"],
      },
    ],
  };

  // Prepare data for the Bar chart
  const barData = data.barData || []; // Make sure to handle undefined
  const barChartData = {
    // labels: barData.map((item) => item.label),
    labels: ["Cash Total", "Card Total"],

    datasets: [
      {
        // label: "Income",
        data: [data.cash_total, data.card_total], // Use the totals for doughnut
        backgroundColor: ["#FF6384", "#36A2EB"],
      },
    ],
  };

  // const handleDateRangeClick = (dateRange) => {
  //   fetchData(dateRange);
  // };

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const response = await OrderServices.getPendingOrder();
  //       console.log("🚀 ~ response:", response);
  //       if (response) {
  //         // Check if there is a pending order
  //         setPendingOrder(response);
  //         setFlashMessage(response); // Set flash message
  //         setTimeout(() => {
  //           setFlashMessage(""); // Clear flash message after 5 seconds
  //         }, 50000);
  //       }
  //     } catch (error) {
  //       console.log("🚀 ~ error:", error);
  //     }
  //   })();
  // }, []);
  const [countData, setCountData] = useState();
  console.log("🚀 ~ Dashboard ~ countData:", countData);

  useEffect(() => {
    const fetchStatusCount = async () => {
      try {
        const response = await TableService.getStatusCount();

        setCountData(response);
      } catch (error) {}
    };

    fetchStatusCount();
  }, []);
  // Calculate total count from all status
  const getTotalCount = () => {
    if (!countData) return 0;
    return countData.reduce((total, item) => total + item.count, 0);
  };

  return (
    <React.Fragment>
      <Container fluid>
        <div className="page-content">
          {/* <Row className="mb-3">
            <Col lg={12} className="text-md-end">
              <Button
                color="primary"
                className="me-2 mb-2"
                onClick={() => handleDateRangeClick("all")}
              >
                All
              </Button>
              <Button
                color="info"
                className="me-2 mb-2"
                onClick={() => handleDateRangeClick("last7days")}
              >
                Last 7 Days
              </Button>
              <Button
                color="warning"
                className="me-2 mb-2"
                onClick={() => handleDateRangeClick("last1months")}
              >
                Last 1 Month
              </Button>
              <Button
                color="danger mb-2"
                onClick={() => handleDateRangeClick("last1year")}
              >
                Last 1 Year
              </Button>
            </Col>
          </Row> */}

          <Row className="">
            <Col lg={8}>
              <Row className="">
                {countData?.map((item, index) => {
                  const config = statusConfig[item.status] || {
                    color: "#333",
                    icon: "bx bx-info-circle",
                  };

                  return (
                    <Col lg={4} md={6} sm={12} key={index}>
                      <Card className="shadow-sm card-animate border-0 ">
                        <CardBody className="d-flex align-items-center justify-content-between">
                          <div className="w-100">
                            <h6
                              className="fw-semibold text-uppercase"
                              style={{ color: config.color }}
                            >
                              {item.status}
                            </h6>
                            <div className="d-flex justify-content-between w-100">
                              <h4
                                className="fs-2 fw-bold"
                                style={{ color: config.color }}
                              >
                                <CountUp
                                  start={0}
                                  end={item.count}
                                  duration={2}
                                  separator=","
                                />
                              </h4>
                              <div
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                  backgroundColor: config.color + "20",
                                  color: config.color,
                                  width: "36px",
                                  height: "36px",
                                }}
                              >
                                <i className={`${config.icon} fs-5`} />
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}

                {/* Total Count Card */}
                <Col lg={4} md={6} sm={12}>
                  <Card className="shadow-sm card-animate border-0 ">
                    <CardBody className="d-flex align-items-center justify-content-between">
                      <div className="w-100">
                        <h6
                          className="fw-semibold text-uppercase"
                          style={{ color: statusConfig.TotalCount.color }}
                        >
                          Total Count
                        </h6>
                        <div className="d-flex justify-content-between w-100">
                          <h4
                            className="fs-2 fw-bold"
                            style={{ color: statusConfig.TotalCount.color }}
                          >
                            <CountUp
                              start={0}
                              end={getTotalCount()}
                              duration={2}
                              separator=","
                            />
                          </h4>
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              backgroundColor:
                                statusConfig.TotalCount.color + "20",
                              color: statusConfig.TotalCount.color,
                              width: "36px",
                              height: "36px",
                            }}
                          >
                            <i
                              className={`${statusConfig.TotalCount.icon} fs-5`}
                            />
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
            <Col>
              <DayCloseDashboard />
            </Col>
          </Row>

          <Row>
            <Col lg={4}>
              <Card className="rounded-4 shadow-sm">
                <CardBody>
                  <QRCodeGenerator />
                </CardBody>
              </Card>
            </Col>
            <Col lg={8}>
              <Widgets />
            </Col>
          </Row>
          <Row className="">
            <Col lg={5} xs={12} className="mb-2">
              <BestSellingProducts />
            </Col>
            <Col lg={7} xs={12}>
              <Revenue />
            </Col>
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
}
